<template>
  <div class="home">
    <div class="zhaoming">
      <div class="lunbo">
        <el-carousel height="420px" autoplay :interval="2000">
          <el-carousel-item v-for="(item, index) in lunbo" :key="index">
            <img :src="item.thumbnail" alt="" class="lunboimg" />
            <div class="zhezhao">
              <p class="title">{{ item.title }}</p>
              <p class="shorttit">
                {{ item.shortTitle }}
              </p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="lunboh5" v-if="lunbo.length > 0">
        <el-carousel height="220px" autoplay :interval="1000">
          <el-carousel-item v-for="(item, index) in lunbo" :key="index">
            <img :src="item.thumbnail" alt="" class="lunboimg" />
            <div class="zhezhao">
              <p class="title">{{ item.title }}</p>
              <p class="shorttit">
                {{ item.shortTitle }}
              </p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="case">
        <div class="about">
          <div class="aboutleft">
            <h2 class="aboutleft-title">关于快加易</h2>
            <p class="desc">一站式企业"数字化"赋能办公解决方案服务商</p>
            <div class="aboutcount" v-html="content"></div>
            <div class="more" @click="goDetal">
              <span>了解更多</span>
              <el-icon class="ml-2">
                <Right />
              </el-icon>
            </div>
          </div>
          <!-- 右侧图片区域 -->
          <div class="aboutright">
            <img
              src="../assets/img/home/图层 1.png"
              alt="公司大楼"
              class="w-full h-[500px] object-cover object-top rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
      <div class="yewu">
        <div class="case">
          <div class="yewutop">
            <h2 class="yewutit">业务中心</h2>
            <p class="yewucont">
              通过云服务覆盖，以服务为本，为客户构建、强力为客户提供优质服务
            </p>
          </div>
          <div class="yewucontent">
            <!-- 左侧遍历前 6 个 -->
            <div class="left">
              <ul
                class="yewuitem"
                v-for="(item, index) in ywList.slice(0, 6)"
                :key="index"
              >
                <li class="yewuicon" @click="goproduct(item)">
                  <img :src="item.icon" alt="" class="icon" />
                  <div class="ywtit">
                    <span class="tit">{{ item.title }}</span>
                  </div>
                  <p>{{ item.content }}</p>
                </li>
              </ul>
            </div>
            <!-- 右侧单独显示最后一个 -->
            <div class="yewuitem-right" v-if="ywList.length > 6">
              <li
                class="yewuicon"
                @click="goproduct(ywList[ywList.length - 1])"
              >
                <img
                  :src="ywList[ywList.length - 1].icon"
                  alt=""
                  class="icon"
                />
                <div class="ywtit">
                  <span class="tit">
                    {{ ywList[ywList.length - 1].title }}</span
                  >
                </div>
                <p>{{ ywList[ywList.length - 1].content }}</p>
              </li>
              <div class="bgimg">
                <img src="@/assets/img/home/5gbg.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="anli">
        <div class="case">
          <div class="anlitop">
            <h2 class="anlitit">部分客户案例分享</h2>
            <p class="anlicont">
              以提升企业
              “创造客户、经营客户”的能力为目标，持续不断的进行产品和技术创新，帮助企业通过更好的经营客户，实现可持续的业务增长。
            </p>
          </div>
          <div class="anlicontent">
            <ul class="anliitem">
              <li
                class="anliindex"
                v-for="(item, index) in alList"
                :key="index"
                @click="goDetali(item)"
              >
                <div class="icontop">
                  <img :src="item.icon" alt="" class="icon" />
                  <div class="iconright">
                    <img src="@/assets/img/home/“.png" alt="" />
                  </div>
                </div>
                <div class="anlitit">{{ item.title }}</div>
                <p class="anlicon">{{ item.content }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="choose">
        <div class="case">
          <div class="choosetop">
            <h2 class="choosetit">众多企业的共同选择</h2>
          </div>
          <div class="chooseqiye">
            <div class="custom-carousel">
              <div class="carousel-wrapper">
                <div
                  class="carousel-item"
                  v-for="(item, index) in qyList"
                  :key="item.id"
                  :class="{ active: index === currentIndex }"
                >
                  <img :src="item.img" alt="Carousel Image" />
                </div>
              </div>
              <div class="carousel-controls">
                <button @click="prevSlide" class="control-btn">
                  <img src="@/assets/img/home/上一个.png" alt="" />
                </button>
                <button @click="nextSlide" class="control-btn">
                  <img src="@/assets/img/home/下一个.png" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="meiti">
        <div class="case">
          <div class="cont">
            <div class="meititop">
              <div class="tab_top">
                <ul>
                  <li
                    :class="active == 1 ? 'li_act' : ''"
                    @click="changeTab(1)"
                  >
                    <p>集团新闻</p>
                    <img src="@/assets/img/info/路径 7.png" alt="" />
                  </li>
                  <li
                    :class="active == 2 ? 'li_act' : ''"
                    @click="changeTab(2)"
                  >
                    <p>业内新闻</p>
                    <img src="@/assets/img/info/路径 7.png" alt="" />
                  </li>
                </ul>
              </div>
              <div class="image-text_31" @click="gomorearticle">
                <span class="text-group_8" style="cursor: pointer">更多</span>
                <el-icon class="ml-2">
                  <ArrowRight />
                </el-icon>
              </div>
            </div>
            <div class="meitibox">
              <ul class="meitiitem">
                <li
                  v-for="(item, index) in mtList"
                  :key="index"
                  @click="goDetali(item)"
                >
                  <div class="left">
                    <h3>{{ item.day }}</h3>
                    <p>{{ item.year }}</p>
                  </div>
                  <div class="right">
                    <h4>{{ item.title }}</h4>
                    <p>{{ item.content }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="position">
        <div class="case">
          <!-- 添加地图 展示公司各分部位置 -->
          <div class="positiontop">
            <!-- <select v-model="selectedBranch" @change="changeBranch">
              <option v-for="(branch, index) in branchList" :key="index" :value="index">
                {{ branch.name }}
              </option>
            </select> -->
            <!-- 公司 -->
            <div class="company">
              <ul>
                <li
                  v-for="(item, index) in branchList"
                  :key="index"
                  @click="changeBranch(index)"
                  :class="{ active: selectedBranch === index }"
                >
                  <div class="left">
                    <div class="mapicon">
                      <img src="@/assets/img/home/地图位置.png" alt="" />
                    </div>
                    <p class="mapindex">{{ index + 1 }}</p>
                  </div>
                  <div class="right">
                    <h4>{{ item.name }}</h4>
                    <p>{{ item.address }}</p>
                  </div>
                </li>
              </ul>
            </div>

            <div id="map"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 侧边联系 -->
    <!-- <div class="dropleft d-ss-none">
        <div class="btn-wrap">
          <div class="icon-wrap phone">
            <img src="@/assets/img/phone.png" class="icon salesBtn2">
            <div class="phone-num">
              <div class="person">李总： 13326966576 </div>
              <div class="trangle"></div>
            </div>
          </div>
          <div class="icon-wrap wechat">
            <img src="@/assets/img/wechat.png" class="icon weBtn">
            <img src="@/assets/img/pic_home_sao.jpeg"
              class="we-code hideMenu showMenu">
          </div>
        </div>
      </div> -->
    <footer class="footer"></footer>
    <!-- </div> -->
  </div>
</template>

<script setup>
import {
  ArrowRight,
  Right,
  // ChatDotRound,
  // Message,
  // Phone,
  // Cloudy,
  // Service,
  // Headset,
} from "@element-plus/icons-vue";
import dxqf from "@/assets/img/home/短信营销-群发短信.svg";
import cxqf from "@/assets/img/home/彩信服务.svg";
import hmjc from "@/assets/img/home/号码检测.svg";
import fivegG from "@/assets/img/home/5G.svg";
import AI from "@/assets/img/home/人工智能.svg";
import hmd from "@/assets/img/home/黑名单.svg";
import yywh from "@/assets/img/home/ic智能电话.svg";

// 案例
import rx from "@/assets/img/home/logo(1).png";
import yw from "@/assets/img/home/34.png";
import hr from "@/assets/img/home/logo(2).png";
import sz from "@/assets/img/home/下载.png";
// cmsArchivesList
import {
  cmsArctypeDetail,
  archive,
  findHeadlineArchive,
} from "@/api/contPublic";
import { ref, onMounted } from "vue";
// import previewblobformCheck from "./previewblobformCheck.vue";
import { useRouter } from "vue-router";
// import AMap from 'AMap'

// 跳转关于我们
const goDetal = () => {
  router.push({ name: "about", params: { id: 15, title: "关于我们" } });
};
// 跳转咨询
const gomorearticle = () => {
  router.push({ name: "news", params: { id: 17, title: "企业资讯" } });
};

// 业务数组
const ywList = ref([
  {
    icon: dxqf,
    title: "短信群发",
    content: "短信验证码、音频通知、合成营销等",
    router: "product",
  },
  {
    icon: cxqf,
    title: "彩信群发",
    content: "会员营销、政府、游戏、金融、教育、房地产等",
    router: "discuss",
  },
  {
    icon: hmjc,
    title: "号码状态检测",
    content:
      "实时查询手机号码的当前在网状态，包括实号，空号，停机，沉默号，风险号等",
    router: "gateway",
  },
  {
    icon: AI,
    title: "人工智能营销引擎",
    content:
      "基于用户网络行为数据和通话行为数据，运用AI技术只能筛选出商家的目标用户人群",
    router: "marketing",
  },
  {
    icon: hmd,
    title: "黑名单检测",
    content: "通过智能算法检测号码是否为敏感用户",
    router: "detection",
  },
  {
    icon: yywh,
    title: "AI人工智能语音外呼服务商",
    content: "语音验证码、会员通知、会员营销等",
    router: "voiceCall",
  },
  {
    icon: fivegG,
    title: "5G消息",
    content:
      "通过支持客户零门槛发送5G消息，赋能客户开创全心服务场景，为行业客户提供5G消息从过度时期到全面覆盖阶段的完整解决方案。",
    router: "message",
  },
]);

const goproduct = (item) => {
  // console.log(item);
  router.push({
    name: item.router,
  });
  window.scrollTo({
    top: 0,
    behavior: "smooth", // 平滑滚动
  });
};
// 案例数组
const alList = ref([
  {
    icon: rx,
    title: "瑞幸咖啡",
    content:
      "瑞幸咖啡作为中国市场上最大的连锁咖啡品牌，通过支持短信群发，就能开创全新的服务场景，为客户提供短信验证码，会员通知，会员营销等。",
  },
  {
    icon: yw,
    title: "永旺超市",
    content:
      "永旺是亚洲领先的综合零售及服务企业集团，主要以经营购物中心、综合零售业（综合百货超市、食品超市）为主。通过支持短信群发，赋能开创全新的服务场景，为客户提供短信验证码、会员通知、会员营销等。",
  },
  {
    icon: hr,
    title: "华润万家",
    content:
      "华润万家是华润集团旗下优秀零售连锁企业，业务覆盖中国内地及香港市场，通过支持短信群发，就能开创全新的服务场景，为客户提供短信验证码、会员通知、会员营销等。",
  },
  {
    icon: sz,
    title: "神州租车",
    content:
      "神州租车有限公司是中国领先的汽车出行服务供应商，为个人及企业客户提供汽车租赁服务，通过支持短信群发，就能开创全新的服务场景，为客户提供短信验证码、会员通知、会员营销等。",
  },
]);
// 企业选择
const qyList = ref([
  { id: 1, img: require("@/assets/img/home/logo1.png") },
  { id: 2, img: require("@/assets/img/home/logo2.png") },
]);
const currentIndex = ref(0); // 当前显示的幻灯片索引
const nextSlide = () => {
  currentIndex.value = (currentIndex.value + 1) % qyList.value.length;
};
const prevSlide = () => {
  currentIndex.value =
    (currentIndex.value - 1 + qyList.value.length) % qyList.value.length;
};
// 媒体报道
const mtList = ref([]);
// 资讯
const active = ref(1);
const changeTab = (i) => {
  active.value = i;
  switch (i) {
    case 1:
      archivesFun(17, "h");
      break;
    case 2:
      archivesFun(17, "a");
      break;
  }
};

// const handleChange = (val) => {
//   currentIndex.value = val;
// };
// const handleClick = () => {};
// const handleClickLeft = () => {};
// const currentIndex = ref(0);
const router = useRouter();
const archivesList = ref([]);
const bloglist = ref([]);
const archivesFun = async (id, flag) => {
  archivesList.value = [];
  bloglist.value = [];
  mtList.value = [];
  // twoList.value = [];
  // slideList.value = [];
  // pictureList.value = [];
  const res = await archive({
    ID: id,
    page: 1,
    pageSize: 100,
    keyword: "",
    flag: flag,
  });

  archivesList.value = res.data.data.list;
  bloglist.value = archivesList.value.filter((item) => {
    if (active.value === 1) {
      return item.flag === "h";
    } else if (active.value === 2) {
      return item.flag === "a";
    }
    return false;
  });
  //  console.log(bloglist.value,'bloglist.value');

  bloglist.value.forEach((item) => {
    // console.log(item);

    if (item.pubDate) {
      const date = new Date(item.pubDate);
      mtList.value.push({
        day: date.getDate().toString().padStart(2, "0"),
        year: `${date.getFullYear()}.${date.getMonth() + 1}`,
        title: item.title,
        content: item.shortTitle,
        ID: item.ID,
        typeId: item.typeId,
      });
    }
  });

  begin();
};
archivesFun(17, "h");
// 轮播图
const lunbo = ref([]);
const begin = async () => {
  // 获取轮播图
  const huan = await findHeadlineArchive({
    page: 1,
    pageSize: 4,
    flag: "p,f",
  });
  // console.log(huan, "huan");

  if (huan.data.code == 0) {
    lunbo.value = huan.data.data;
    // if(lunbo.value.length==1){
    //   lunFlag.value=true
    // }else if(lunbo.value.length>1){
    //   lunFlag.value=false
    // }
    // console.log(lunFlag.value);
  }
};
// 分公司列表
const branchList = ref([
  {
    name: "公司总部",
    address: "广州市天河区黄埔大道西100号之二503、504房",
    location: { lng: 113.344, lat: 23.125 },
  },
  {
    name: "上海分公司",
    address: "上海市松江区蒲汇路178弄2号九亭U天地506室",
    location: { lng: 121.341, lat: 31.112 },
  },
  {
    name: "中山分公司",
    address: "中山市东区中山六路3号庆丰德远大厦6层604房",
    location: { lng: 113.399, lat: 22.515 },
  },
  {
    name: "深圳分公司",
    address: "深圳市宝安区西乡街道固兴社区新屋园一巷7号万联大厦第9楼第905",
    location: { lng: 113.883, lat: 22.553 },
  },
  {
    name: "北京分公司",
    address: "北京市朝阳区建外街道西大望路甲3号蓝堡国际中心1座2207A",
    location: { lng: 116.468, lat: 39.914 },
  },
]);

// 当前选中的分公司索引
const selectedBranch = ref(0);

// 地图对象
let map;

// 初始化地图
const initMap = () => {
  if (window.AMap) {
    map = new window.AMap.Map("map", {
      zoom: 12, // 地图缩放级别
      center: [
        branchList.value[selectedBranch.value].location.lng,
        branchList.value[selectedBranch.value].location.lat,
      ], // 地图中心点
    });

    // 添加标记
    const marker = new window.AMap.Marker({
      position: [
        branchList.value[selectedBranch.value].location.lng,
        branchList.value[selectedBranch.value].location.lat,
      ],
      map: map,
    });

    // 创建信息窗口
    const infoWindow = new window.AMap.InfoWindow({
      content: `<div class="custom-marker" style="width: 300px;">
                  <p>${branchList.value[selectedBranch.value].address}</p>
                </div>`,
      offset: new window.AMap.Pixel(0, -30),
    });

    // 打开信息窗口
    infoWindow.open(map, marker.getPosition());

    marker.setMap(map);
  } else {
    console.error("高德地图 API 未加载完成");
  }
};

// 切换分公司
const changeBranch = (index) => {
  selectedBranch.value = index;
  if (map) {
    const point = [
      branchList.value[selectedBranch.value].location.lng,
      branchList.value[selectedBranch.value].location.lat,
    ];
    // 禁用地图动画效果
    map.setZoomAndCenter(map.getZoom(), point, { animate: false });

    // 清除之前的标记和信息窗口
    map.clearMap();

    // 添加新的标记
    const marker = new window.AMap.Marker({
      position: point,
    });

    // 创建新的信息窗口，设置宽度为 300px
    const infoWindow = new window.AMap.InfoWindow({
      content: `<div class="custom-marker" style="width: 300px;">
                  <p>${branchList.value[selectedBranch.value].address}</p>
                </div>`,
      offset: new window.AMap.Pixel(0, -30),
    });

    // 直接打开信息窗口
    infoWindow.open(map, marker.getPosition());
    marker.setMap(map);
  }
};

onMounted(() => {
  if (window.AMap) {
    initMap();
  } else {
    window.addEventListener("load", initMap);
  }
});

const content = ref("");
const contentFun = async () => {
  const res = await cmsArctypeDetail({ ID: 13 });
  // console.log(res, "res");

  content.value = res.data.data.content;
};
contentFun();

const goDetali = (item) => {
  // console.log(item);
  router.push({
    name: "newsDataViewAfter",
    params: { id: item.typeId, title: item.title, ids: item.ID },
  });
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.case {
  width: 1200px;
  margin: 0 auto;
}
.zhaoming {
  // width: 100%;
  min-width: 1200px;
  .lunboh5 {
    display: none;
  }
  .lunbo {
    width: 100%;
    position: relative;
    .el-carousel__item {
      height: 420px;
      .lunboimg {
        position: relative;
        width: 100%;
        height: 420px;
        object-fit: cover;
      }
      .zhezhao {
        width: 100%;
        height: 50px;
        position: absolute;
        top: 25%;
        left: -50%;
        transform: translate(50%, 50%);
        z-index: 1;
        text-align: center;
        .title {
          font-size: 44px;
          font-weight: 700;
          color: #fff;
          margin-bottom: 20px;
          position: relative;
          // // 第一张
          // &:nth-child(1) {
          //   &::after {
          //   position: absolute;
          //   left: 50%;
          //   left: 50%;
          //   top: 45px;
          //   z-index: -1;
          //   transform: translateX(-50%);
          //   content: " ";
          //   display: block;
          //   width: 128px;
          //   height: 15px;
          //   background-color:#FF7700;
          // }
          // }
        }
        .shorttit {
          font-size: 24px;
          font-weight: 300;
          color: #fff;
        }
      }
    }
  }

  .about {
    display: flex;
    margin: 50px auto;

    // height: 425px;
    .aboutleft {
      flex: 1;
      text-align: left;

      .aboutleft-title {
        font-size: 32px;
        color: #182204;
        font-weight: 700;
        margin-bottom: 16px;
        position: relative;
        &::before {
          position: absolute;
          left: 0;
          top: -8px;
          content: "";
          display: block;
          width: 102px;
          height: 3px;
          background-color: #1456f0;
          margin-bottom: 25px;
        }
      }

      .desc {
        font-size: 16px;
        color: #999999;
        margin-bottom: 30px;
      }

      .aboutcount {
        font-size: 16px;
        color: #182204;
        line-height: 30px;
        margin-bottom: 33px;
      }

      .more {
        border: 1px solid #4385ff;
        width: 160px;
        height: 50px;
        font-size: 16px;
        color: #4385ff;
        cursor: pointer;
        text-align: center;
        line-height: 50px;
      }
    }

    .aboutright {
      flex: 1;
      margin-left: 80px;

      & > img {
        width: 490px;
        height: 422px;
      }
    }
  }

  .yewu {
    background-color: #f3f6fb;
    padding: 60px 0;

    .yewutop {
      text-align: center;
      margin-bottom: 33px;

      .yewutit {
        font-weight: 700;
        font-size: 32px;
        color: #182204;
        margin-bottom: 16px;
      }

      .yewucont {
        font-size: 16px;
        color: #999999;
      }
    }

    .yewucontent {
      display: flex;
      width: 100%;
      height: 495px;

      .left {
        display: flex;
        flex: 4;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        align-content: space-between;
      }

      .yewuitem-right {
        flex: 1;
        padding: 20px;
        height: 495px;
        background-color: #fff;
        position: relative;
        li {
          list-style-type: none; // 去除列表项的点
        }
        .bgimg {
          position: absolute;
          left: 90px;
          top: 315px;
          width: 180px;
          height: 180px;
          z-index: 1;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .yewuicon {
          text-align: left;
          .icon {
            // width: 40px;
            // height: 38px;
          }

          .ywtit {
            // font-size: 18px;
            font-weight: 700;
            color: #182204;
            margin-top: 26px;
            margin-bottom: 16px;
            .tit {
              position: relative;
              z-index: 1;
              &::after {
                position: absolute;
                content: "";
                display: block;
                height: 13px;
                background-color: #caddff;
                margin-top: -15px;
                width: 100%;
                z-index: -1;
              }
            }

            p {
              font-size: 14px;
              color: #182204;
              // 新增：超出部分省略号展示
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3; // 最多显示 3 行
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 1.5; // 可根据实际情况调整行高
            }
          }
        }
        &:hover {
          transform: scale(1.05);
        }
      }

      .yewuitem {
        width: calc(33% - 24px);
        height: 240px;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        margin-right: 20px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.05);
        }

        &:nth-child(3n) {
          margin-right: 0;
        }

        &:nth-child(6n) {
          margin-left: 0;
        }

        .yewuicon {
          text-align: left;

          .icon {
            // width: 40px;
            // height: 38px;
            & > img {
              // width: 40px;
              // height: 38px;
            }
          }

          .ywtit {
            // font-size: 18px;
            font-weight: 700;
            color: #182204;
            margin-top: 26px;
            margin-bottom: 16px;

            .tit {
              position: relative;
              z-index: 1;
              &::after {
                position: absolute;
                content: "";
                display: block;
                height: 13px;
                background-color: #caddff;
                margin-top: -15px;
                width: 100%;
                z-index: -1;
              }
            }

            p {
              font-size: 14px;
              color: #182204;
              // 新增：超出部分省略号展示
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3; // 最多显示 3 行
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 1.5; // 可根据实际情况调整行高
            }
          }
        }
      }
    }
  }

  .anli {
    background-image: url(@/assets/img/home/23.png);

    .anlitop {
      padding-top: 50px;
      text-align: center;

      .anlitit {
        font-weight: 700;
        font-size: 32px;
        color: #fff;
        margin-bottom: 16px;
      }

      .anlicont {
        text-align: center;
        max-width: 565px;
        font-size: 16px;
        color: #fff;
        margin: 0 auto;
        line-height: 22px;
      }
    }

    .anlicontent {
      margin: 55px auto;

      .anliitem {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;

        .anliindex {
          width: calc(49% - 10px);
          margin-right: 26px;
          margin-bottom: 26px;
          cursor: pointer;
          height: 240px;
          background-color: #fff;
          padding: 27px 32px;

          // 第二个第四个不要右边距
          &:nth-child(2n) {
            margin-right: 0;
          }

          &:hover {
            transform: scale(1.05);
          }

          .icontop {
            display: flex;
            justify-content: space-between;

            // .icon {
            //   width: 50px;
            //   height: 50px;
            // }
            .iconright {
              width: 35px;
              height: 35px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .anlitit {
            font-weight: 700;
            margin-top: 22px;
            font-size: 18px;
            color: #182204;
          }

          .anlicon {
            font-size: 14px;
            color: #182204;
            margin-top: 13px;
            // 优化超出省略号展示
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3; // 最多显示 3 行
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.5;
          }
        }
      }
    }
  }

  .choose {
    text-align: center;

    // margin: 80px auto;
    .choosetop {
      .choosetit {
        font-size: 32px;
        color: #182204;
        font-weight: 700;
        margin-bottom: 53px;
      }
    }

    .chooseqiye {
      height: 566px;

      .custom-carousel {
        position: relative;
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
      }

      .carousel-wrapper {
        display: flex;
        transition: transform 0.3s ease-in-out;
      }

      .carousel-item {
        min-width: 100%;
        display: none;
        justify-content: center;
        align-items: center;
      }

      .carousel-item.active {
        display: flex;
        transition: transform 0.5s ease, opacity 0.5s ease;
      }

      .carousel-item img {
        border-radius: 8px;
        -webkit-mask-image: linear-gradient(
          to right,
          transparent,
          black 20%,
          black 80%,
          transparent
        );
        animation: fadeIn 1.5s ease-in;
        object-fit: contain;
        /* 添加慢入动画，持续时间为 1.5 秒 */
        @keyframes fadeIn {
          from {
            opacity: 0;
          }

          to {
            opacity: 1;
          }
        }

        mask-image: linear-gradient(
          to right,
          transparent,
          black 20%,
          black 80%,
          transparent
        );
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
      }

      .carousel-indicators {
        display: flex;
        justify-content: center;
        margin-top: 20px;
      }

      .carousel-controls {
        position: absolute;
        top: 50%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        transform: translateY(-50%);
        pointer-events: none;
      }

      .control-btn {
        img {
          width: 22px;
          height: 42px;
        }

        border: none;
        cursor: pointer;
        font-size: 24px;
        outline: none;
        transition: background-color 0.3s;
        pointer-events: auto;
        background-color: #fff;
      }

      .control-btn:hover {
        background-color: rgba(199, 194, 194, 0.8);
      }

      .prev-btn {
        position: absolute;
        left: -50px;
      }

      .next-btn {
        position: absolute;
        right: -50px;
      }
    }
  }

  .meiti {
    text-align: center;
    background: linear-gradient(to right, #ffffff 0%, #e7f0fb 100%);
    // height: 418px;

    .meititop {
      width: 100%;
      border-bottom: 1px solid #c1cdd8;
      position: relative;
      padding-top: 70px;

      & > .tab_top {
        width: 100%;
        & > ul {
          width: 100%;
          display: flex;
          justify-content: center;
          & > li {
            font-size: 20px;
            cursor: pointer;
            line-height: 30px;
            margin: 0 20px;
            text-align: center;
            display: flex;
            align-items: center;
            color: #989898;
            height: 64px;
            justify-content: space-around;
            flex-direction: column;
            & > img {
              width: 0;
              transition: all 0.3s;
            }
            & > p {
              transition: all 0.3s;
            }
            &.li_act {
              & > p {
                color: #182204;
                font-size: 32px;
                line-height: 50px;
                font-weight: 700;
              }
              & > img {
                width: 30px;
              }
            }
          }
        }
      }
      .image-text_31 {
        width: 57px;
        height: 28px;
        margin: 31px 0 0 398px;
        display: flex;
        align-items: center;
        position: absolute;
        right: 0;
        bottom: 0;
        color: #989898;
      }

      .text-group_8 {
        width: 40px;
        height: 28px;
        overflow-wrap: break-word;
        color: #989898;
        font-size: 20px;
        font-weight: normal;
        text-align: center;
        white-space: nowrap;
        line-height: 28px;
      }

      .thumbnail_1 {
        width: 30px;
        height: 14px;
        margin-top: 9px;
      }
    }

    .meitibox {
      min-height: 120px;
      .meitiitem {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        li {
          width: calc(33% - 20px);
          margin-right: 20px;
          // margin-bottom: 20px;
          height: 100px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          &:nth-child(n + 10) {
            display: none;
          }
          .left {
            text-align: center;
            width: 48px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            margin-right: 16px;

            h3 {
              font-size: 20px;
              color: #182204;
              font-weight: 700;
              margin-right: 10px;
            }

            p {
              font-size: 12px;
              color: #909090;
            }
          }

          .right {
            max-width: 320px;
            text-align-last: left;

            h4 {
              max-width: 200px;
              font-size: 14px;
              color: #262626;
              font-weight: 700;
              margin-right: 10px;
              // 超出部分省略号显示
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            p {
              max-width: 200px;
              font-size: 12px;
              color: #848484;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  .position {
    width: 100%;
    height: 100%;
    margin: 60px auto;

    .positiontop {
      .company {
        width: 200px;
        height: 400px;
        background-color: #ffffff;
        // 纵向滚动条
        overflow-y: auto;
        position: absolute;
        z-index: 1;
        margin: 10px;
        ul {
          .active {
            background-color: #dee2e6;
          }
          li {
            padding: 15px;
            width: 100%;
            display: flex;
            justify-content: space-around;
            .left {
              width: 30px;
              height: 30px;
              margin-right: 5px;
              position: relative;
              color: #fff;
              .mapicon {
                width: 30px;
                height: 30px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .mapindex {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 14px;
                z-index: 1;
              }
            }
            .right {
              h4 {
                font-size: 18px;
                color: #333;
                line-height: 5px;
                font-weight: 700;
              }
              p {
                font-size: 14px;
                color: #666;
                padding: 8px 0;
              }
            }
          }
        }
      }
      #map {
        width: 100%;
        height: 600px;
        border: 1px solid #059df5;
        width: 100%;
        .amap-layers {
          position: relative;
        }
      }
    }
  }
}
// 移动端等比缩放样式
// @media (max-width: 768px) {
//   .case {
//     width: 100%; // 让容器宽度与屏幕宽度一致
//     padding: 0 15px; // 增加内边距，避免内容紧贴屏幕边缘
//     box-sizing: border-box; // 使内边距包含在宽度内
//   }
//   .zhaoming {
//     min-width: auto; // 去除最小宽度限制
//     // 可根据需要调整其他样式，保持整体布局
//     .about {
//       // 例如：如果需要调整布局方向
//       // flex-direction: column;
//       margin: 20px auto;
//     }
//     .zhaoming .yewu .yewucontent {
//     // 让元素换行显示
//     flex-wrap: wrap;
//   }
//   .zhaoming .yewu .yewucontent .left {
//     // 小屏幕下左侧元素占满宽度
//     flex-basis: 100%;
//   }
//   .zhaoming .yewu .yewucontent .yewuitem {
//     // 小屏幕下每个业务项占满宽度
//     width: 100%;
//     margin-right: 0;
//     margin-bottom: 20px;
//   }
//   .zhaoming .yewu .yewucontent .yewuitem-right {
//     // 小屏幕下右侧单独项占满宽度
//     flex-basis: 100%;
//     padding: 20px;
//     height: auto;
//   }
//   .zhaoming .meiti .meitibox .meitiitem li {
//     // 小屏幕下每个媒体报道项占满宽度
//     width: 100%;
//     margin-right: 0;
//     margin-bottom: 20px;
//   }
//   .zhaoming .meiti .meitibox .meitiitem li .right {
//     // 右侧文字区域自适应宽度
//     max-width: calc(100% - 64px);
//   }
//   }
// }
// 移动端样式调整
@media (max-width: 768px) {
  .case {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
  }

  .zhaoming {
    margin-top: 63px;
    min-width: auto;
    .lunbo {
      display: none;
    }
    .lunboh5 {
      display: block;
      width: 100%;
      height: auto !important;
      position: relative;
      .el-carousel__item {
        height: 220px;
        .lunboimg {
          position: relative;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .zhezhao {
          width: 100%;
          height: 50px;
          position: absolute;
          top: 25%;
          left: -50%;
          transform: translate(50%, 50%);
          z-index: 1;
          text-align: center;
          .title {
            font-size: 30px;
            font-weight: 700;
            color: #fff;
            margin-bottom: 20px;
            position: relative;
            // &::after {
            //   position: absolute;
            //   left: 50%;
            //   left: 50%;
            //   top: 35px;
            //   z-index: -1;
            //   transform: translateX(-50%);
            //   content: " ";
            //   display: block;
            //   width: 100px;
            //   height: 6px;
            //   background-color:#FF7700;
            // }
          }
          .shorttit {
            font-size: 18px;
            font-weight: 200;
            color: #fff;
          }
        }
      }
    }

    .about {
      flex-direction: column;
      margin: 20px auto;

      .aboutleft {
        margin-bottom: 20px;
      }

      .aboutright {
        margin-left: 5px;
        & > img {
          width: 100%;
          height: auto;
        }
      }
    }

    .yewu {
      padding: 30px 0;

      .yewucontent {
        flex-direction: column;
        height: auto;

        .left {
          flex: auto;
        }

        .yewuitem-right {
          flex: auto;
          height: auto;
          .bgimg {
            display: none;
          }
        }

        .yewuitem {
          width: 100%;
          margin-right: 0;
          margin-bottom: 20px;
        }
      }
    }

    .anli {
      .anlicontent {
        .anliitem {
          .anliindex {
            width: 100%;
            margin-right: 0;
            margin-bottom: 20px;
          }
        }
      }
    }

    .choose {
      .chooseqiye {
        height: auto;
        img {
          width: 100%;
          height: auto;
          object-fit: contain; /* 确保图片内容完整显示 */
        }
      }
    }

    .meiti {
      height: auto;
      padding-bottom: 30px;
      .meititop {
        .image-text_31 {
          .text-group_8 {
            display: none;
          }
        }
      }

      .meitibox {
        .meitiitem {
          li {
            width: 100%;
            margin-right: 0;
            margin-bottom: 0;
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
          }
          .right {
            p {
              text-align: left;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }

    .position {
      .positiontop {
        .company {
          width: 100px; /* 调整宽度 */
          height: 200px; /* 调整高度 */
          ul li {
            .left {
              display: none;
              .mapindex {
                font-size: 12px; /* 调整地图索引字体大小 */
              }
            }
            .right h4 {
              font-size: 14px; /* 调整公司名称字体大小 */
            }
            .right p {
              display: none;
              font-size: 12px; /* 调整公司地址字体大小 */
            }
          }
        }
        #map {
          width: 100%;
          height: 400px; /* 调整高度 */
        }
      }
    }
  }
}
</style>